import React, { useRef, useState } from 'react';
import 'ol/ol.css';
import { toLonLat, fromLonLat } from 'ol/proj';

import { OverlayContainer } from './layers/OverlayContainer';
import { Map as OlMap, Feature } from 'ol';
import { Point } from 'ol/geom';
import { getDarkTileLayers, getView, setSourceForGeoJSON, runAnimationLayerList } from './OlExtension';
import { Cluster } from 'ol/source'

import DisplayLink2PolygonLayer from './layers/DisplayLink2PolygonLayer';
import DisplayIntersectionPointLayer from './layers/DisplayIntersectionPointLayer';
import EmergencyVehicleLayer from './layers/EmergencyVehicleLayer';
import { settingsConfig, toFormatedDateHHmmss, toFormatedDateYYYYMMDDHHmm } from 'utils/commonFunc';
import CommonBoundaryLayer from './layers/CommonBoundaryLayer';
import CommonMarkerLayer from './layers/CommonMarkerLayer';
import CommonPoiLayer from './layers/CommonPoiLayer';

import ApiService from "services/ApiService";

import defColors from 'utils/defColors';

import LayerFacilityVds from './layers/LayerFacilityVds';
import LayerFacilityCctv from './layers/LayerFacilityCctv';
import LayerFacilityAccessCctv from './layers/LayerFacilityAccessCctv';
import LayerFacilityVms from './layers/LayerFacilityVms';
import LayerFacilityDsrc from './layers/LayerFacilityDsrc2';
import LayerFacilitySurf from './layers/LayerFacilitySurf';
import LayerFacilityCrsr from './layers/LayerFacilityCrsr';
import LayerFacilitySgnInf from './layers/LayerFacilitySgnInf';

import LayerTrafficLos from './layers/LayerTrafficLos';
import LayerTrafficPark from './layers/LayerTrafficPark';
import LayerTrafficHaza from './layers/LayerTrafficHaza';

import LayerSafeSelfLink from './layers/LayerSafeSelfLink';

import LayerBisBus from './layers/LayerBisBus';
import LayerBisStop from './layers/LayerBisStop';
import LayerBisStop2 from './layers/LayerBisStop2';
import LayerBisBit from './layers/LayerBisBit';
import LayerBisPass from './layers/LayerBisPass';

import LayerFacilitySign from './layers/LayerFacilitySign';
import LayerSafeZone from './layers/LayerSafeZone';
import LayerSchoolZone from './layers/LayerSchoolZone';
import LayerLinkHeat from './layers/LayerLinkHeat';
import LayerBusHeat from './layers/LayerBusHeat';
import LayerBusHeatGetOn from './layers/LayerBusHeatGetOn';
import LayerBusHeatGetOff from './layers/LayerBusHeatGetOff';
import LayerSelfVhc from './layers/LayerSelfVhc';
import LayerPointPin from './layers/LayerPointPin';
import LayerFacilityCctvOverview from './layers/LayerFacilityCctvOverview';

import { PopupViewVds } from 'pages/components/PopupViewVds';
import { PopupViewCctv } from 'pages/components/PopupViewCctv';
import { PopupViewAccessCctv } from 'pages/components/PopupViewAccessCctv';
import { PopupViewVms } from 'pages/components/PopupViewVms';
import { PopupViewDsrc } from 'pages/components/PopupViewDsrc';
import { PopupViewSurf } from 'pages/components/PopupViewSurf';
import { PopupViewCrsr } from 'pages/components/PopupViewCrsr';
import { PopupViewSgnInf } from 'pages/components/PopupViewSgnInf';

import { PopupViewPark } from 'pages/components/PopupViewPark';
import { PopupViewStop } from 'pages/components/PopupViewStop';
import { PopupViewHaza } from 'pages/components/PopupViewHaza';

import { PopupViewBit } from 'pages/components/PopupViewBit';
import { PopupViewPass } from 'pages/components/PopupViewPass';
import { PopupViewInout } from 'pages/components/PopupViewInout';

import { PopupViewEmer } from 'pages/components/PopupViewEmer';
import { PopupViewDataProcess } from 'pages/components/PopupViewDataProcess';
import { PopupViewSign } from 'pages/components/PopupViewSign';
import { PopupViewSafeZone } from 'pages/components/PopupViewSafeZone';
import { PopupViewSchoolZone } from 'pages/components/PopupViewSchoolZone';
import { PopupViewBisSvrStat } from 'pages/components/PopupViewBisSvrStat';

const DashboardMap = React.forwardRef((props, ref) => {


    const {
        link2GeoJson,
        currentLink2Data,
        vehicleItems,
        passengerData,
        inOutTrfData,
        hazaData,
        allLayerList,
        timerIndex,
        timerDate,
        setLoaded1,
        setLoaded2,
        setLoaded3,
    } = props

    const divRef = useRef(null);
    const mapObjRefs = useRef(null);
    const overlayContainerRef = useRef(null);
    const latestProps = useRef({});

    const intervalRef = useRef(null); // 형련 추가 미래교통 위치 갱신용

    const [isDataLoaded_busHeatLayer, setIsDataLoaded_busHeatLayer] = useState(false);
    const [isDataLoaded_busHeatLayerGetOn, setIsDataLoaded_busHeatLayerGetOn] = useState(false);
    const [isDataLoaded_busHeatLayerGetOff, setIsDataLoaded_busHeatLayerGetOff] = useState(false);

    latestProps.current = {
        link2GeoJson,
        currentLink2Data,
        vehicleItems,
        passengerData,
        inOutTrfData,
        hazaData,
        allLayerList,
        timerIndex,
        timerDate,
        setLoaded1,
        setLoaded2,
        setLoaded3,
    };

    React.useImperativeHandle(ref, () => ({
        AddEmergencyVehicleRoute,
        RemoveEmergencyVehicleRoute,
        SetMapView,
        SetLayerVisible,
    }))

    React.useEffect(() => {
        const handleKeyUp = (event) => {
            if (event.ctrlKey && event.code === 'ArrowRight') {
                const map = mapObjRefs.current.map;
                const layer = map.getLayers().getArray().find(x => x.values_.name === 'base');
                if (layer) {
                    layer.setVisible(!layer.getVisible());
                }
            }
            if (event.ctrlKey && event.code === 'ArrowUp') {
                const map = mapObjRefs.current.map;
                const layer = map.getLayers().getArray().find(x => x.values_.name === 'boundary');
                if (layer) {
                    layer.setVisible(!layer.getVisible());
                }
            }
            if (event.ctrlKey && event.code === 'ArrowDown') {
                const map = mapObjRefs.current.map;
                const layer = map.getLayers().getArray().find(x => x.values_.name === 'pointPinLayer');
                if (layer) {
                    layer.setVisible(!layer.getVisible());
                }
            }
        };
        window.addEventListener('keyup', handleKeyUp);
        return () => {
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, []);

    React.useEffect(() => {
        if (divRef.current) {
            const map = new OlMap({
                target: divRef.current,
                controls: [],
                layers: [...getDarkTileLayers({ tileUrl: window.serviceConfig?.tileUrl, opacity: 0.8 })],
                //view: getView(14.5, fromLonLat([127.01164, 37.27800])), // 기존값과 같다.
                view: getView(13.8, fromLonLat([127.02, 37.287])),
                //view: getView(13.5, fromLonLat([127.05000, 37.28800])),
            })

            map.on('click', handleClick);

            if (settingsConfig().mapPoiMode === 1) {
                map.addLayer(new CommonPoiLayer(map));
            }
            else if (settingsConfig().mapPoiMode === 2) {
                map.addLayer(new CommonBoundaryLayer(map, { transparency: true }));
                //map.addLayer(new CommonPoiLayer(map));
            }

            const busLayer = new LayerBisBus(map);
            const styleCache = { needFlashEnabled: true }
            const loopStyleDef = [
                { tp: 14, color: defColors.bus.code14 },
                { tp: 13, color: defColors.bus.code13 },
                { tp: 30, color: defColors.bus.code30 },
                { tp: undefined, color: 'rgb(50, 255, 50)' }
            ]
            loopStyleDef.forEach(p => {
                styleCache[p.tp] = busLayer.getVehicleStyle({ tp: p.tp })
            })

            const cctvOverviewLayer = new LayerFacilityCctvOverview(map);

            const cctvLayer = new LayerFacilityCctv(
                map,
                dataset => cctvOverviewLayer.setDataset('cctv', dataset)
            );

            const accessCctvLayer = new LayerFacilityAccessCctv(
                map,
                dataset => cctvOverviewLayer.setDataset('accessCctv', dataset)
            );

            mapObjRefs.current = {
                map,
                link2Layer: new DisplayLink2PolygonLayer(map),
                // pointPinLayer: new LayerPointPin(map),

                vdsLayer: new LayerFacilityVds(map),
                cctvOverviewLayer,
                cctvLayer,
                accessCctvLayer,
                vmsLayer: new LayerFacilityVms(map),
                dsrcLayer: new LayerFacilityDsrc(map),
                surfLayer: new LayerFacilitySurf(map),
                crsrLayer: new LayerFacilityCrsr(map),
                sgnInfLayer: new LayerFacilitySgnInf(map),

                parkLayer: new LayerTrafficPark(map),
                // losLayer: new LayerTrafficLos(map),
                hazaLayer: new LayerTrafficHaza(map),

                selfLinkLayer: new LayerSafeSelfLink(map),

                styleCache,
                busLayer: busLayer,
                // stopLayer: new LayerBisStop(map),
                // stopLayer2: new LayerBisStop2(map), 
                bitLayer: new LayerBisBit(map),

                signLayer: new LayerFacilitySign(map),
                // safeZoneLayer: new LayerSafeZone(map),
                schoolZoneLayer: new LayerSchoolZone(map),

                linkHeatLayer: new LayerLinkHeat(map),
                busHeatLayer: new LayerBusHeat(map),
                busHeatLayerGetOn: new LayerBusHeatGetOn(map),
                busHeatLayerGetOff: new LayerBusHeatGetOff(map),

                selfVhcLayer: new LayerSelfVhc(map),

                emergencyVehicleLayer: new EmergencyVehicleLayer(map),
                pointPinLayer: new LayerPointPin(map),
            };

            map.getView().on('change:resolution', function () {
                mapObjRefs.current.losLayer?.changed();
                //console.log('zoom factor', mapObjRefs.current.map.getView().getZoom())
                updateCctvLayerVisibility();
            });

            // default 버스히트맵 데이터 조회
            if (timerDate) {
                let dateStr = timerDate.replaceAll('-', '');                
                mapObjRefs.current.busHeatLayerGetOn?.setHeatData(dateStr);
                mapObjRefs.current.busHeatLayerGetOff?.setHeatData(dateStr);
                mapObjRefs.current.busHeatLayer?.setHeatData(dateStr);
                mapObjRefs.current.linkHeatLayer?.setHeatData(dateStr);
            }

            const checkInterval1 = setInterval(() => {
                if (mapObjRefs.current.busHeatLayer._isDataLoaded) {
                    setIsDataLoaded_busHeatLayer(true);
                    clearInterval(checkInterval1);
                }
            }, 300);
            const checkInterval2 = setInterval(() => {
                if (mapObjRefs.current.busHeatLayerGetOn._isDataLoaded) {
                    setIsDataLoaded_busHeatLayerGetOn(true);
                    clearInterval(checkInterval2);
                }
            }, 300);
            const checkInterval3 = setInterval(() => {
                if (mapObjRefs.current.busHeatLayerGetOff._isDataLoaded) {
                    setIsDataLoaded_busHeatLayerGetOff(true);
                    clearInterval(checkInterval3);
                }
            }, 300);

            return () => {
                map.setTarget(undefined);
            }
        }
    }, [divRef]);

    React.useEffect(() => {
        setLoaded1(isDataLoaded_busHeatLayer);
    }, [isDataLoaded_busHeatLayer]);
    React.useEffect(() => {
        setLoaded2(isDataLoaded_busHeatLayerGetOn);
    }, [isDataLoaded_busHeatLayerGetOn]);
    React.useEffect(() => {
        setLoaded3(isDataLoaded_busHeatLayerGetOff);
    }, [isDataLoaded_busHeatLayerGetOff]);

React.useEffect(() => {
        setSourceForGeoJSON(mapObjRefs.current?.link2Layer, link2GeoJson)
    }, [link2GeoJson]);

    React.useEffect(() => {
        if (currentLink2Data?.link2SpdRows) {
            mapObjRefs.current?.link2Layer?.updateSpd(currentLink2Data.link2SpdRows);
        }
    }, [currentLink2Data]);
    // 버스차량
    React.useEffect(() => {
        const items = vehicleItems;
        const layer = mapObjRefs.current?.busLayer;
        const styleCache = mapObjRefs.current?.styleCache;
        if (layer && items) {
            const source = layer.getSource()
            source.clear()
            items.forEach(item => {
                const feature = new Feature({
                    geometry: new Point(fromLonLat([item.x, item.y])),
                    ...item
                });
                const tp = feature.get("routeTp")
                let style = styleCache[tp];
                if (!style) {
                    style = styleCache[undefined]
                }

                feature.setStyle(style)
                source.addFeature(feature)
            })

            if (styleCache.needFlashEnabled) {
                startFlashFeature();
                styleCache.needFlashEnabled = false;
            }
        }
    }, [vehicleItems]);
    // 유출입
    React.useEffect(() => {
        if (allLayerList.find(x => x.layer === 'inoutLayer')?.checked) {
            AddInOutTrf();
        }
    }, [inOutTrfData]);
    // 승하차인원현황
    React.useEffect(() => {
        if (allLayerList.find(x => x.layer === 'passLayer')?.checked) {
            AddPassenger();
        }
    }, [passengerData]);
    // 위험물차량
    React.useEffect(() => {
        mapObjRefs.current?.hazaLayer?.setData(hazaData);
    }, [hazaData]);
    // 도로소통 and 버스히트맵 slidebar
    React.useEffect(() => {
        let dateStr = timerDate.replaceAll('-', '');
        let timeStr = "";
        if (timerIndex < 10) {
            timeStr = '0' + timerIndex;
        } else {
            timeStr += timerIndex;
        }
        let dateTimeStr = dateStr + timeStr;
        if (allLayerList.find(x => x.layer === 'linkHeatLayer')?.checked) {
            mapObjRefs.current.linkHeatLayer?.changeTime(dateTimeStr);
        }
        if (allLayerList.find(x => x.layer === 'busHeatLayerGetOn')?.checked
            && allLayerList.find(x => x.layer === 'busHeatLayerGetOff')?.checked) {
            mapObjRefs.current.busHeatLayer?.changeTime(timeStr);
        } else if (allLayerList.find(x => x.layer === 'busHeatLayerGetOn')?.checked) {
            mapObjRefs.current.busHeatLayerGetOn?.changeTime(timeStr);
        } else if (allLayerList.find(x => x.layer === 'busHeatLayerGetOff')?.checked) {
            mapObjRefs.current.busHeatLayerGetOff?.changeTime(timeStr);
        }
    }, [timerIndex]);
    // 도로소통 and 버스히트맵 input date
    React.useEffect(() => {
        let dateStr = timerDate.replaceAll('-', '');
        if (allLayerList.find(x => x.layer === 'linkHeatLayer')?.checked) {
            mapObjRefs.current.linkHeatLayer?.setHeatData(dateStr);
        }
        if (allLayerList.find(x => x.layer === 'busHeatLayerGetOn')?.checked
            && allLayerList.find(x => x.layer === 'busHeatLayerGetOff')?.checked) {
            mapObjRefs.current.busHeatLayer?.setHeatData(dateStr);
        } else if (allLayerList.find(x => x.layer === 'busHeatLayerGetOn')?.checked) {
            mapObjRefs.current.busHeatLayerGetOn?.setHeatData(dateStr);
        } else if (allLayerList.find(x => x.layer === 'busHeatLayerGetOff')?.checked) {
            mapObjRefs.current.busHeatLayerGetOff?.setHeatData(dateStr);
        }
    }, [timerDate]);

    // 줌 15 이상에서는 기존 CCTV·접근로 아이콘 표시
    const CCTV_DETAIL_MIN_ZOOM = 15;

    const updateCctvLayerVisibility = () => {
        const map = mapObjRefs.current?.map;

        if (!map) {
            return;
        }

        // CCTV 체크박스 상태
        const cctvChecked = latestProps.current.allLayerList?.find(
            item => item.layer === 'cctvLayer'
        )?.checked;

        const zoom = map.getView().getZoom();
        const showDetailLayers = zoom >= CCTV_DETAIL_MIN_ZOOM;

        // 축소 화면에서는 통합 클러스터 표시
        mapObjRefs.current.cctvOverviewLayer?.setVisible(
            cctvChecked && !showDetailLayers
        );

        // 확대 화면에서는 기존 일반 CCTV 표시
        mapObjRefs.current.cctvLayer?.setVisible(
            cctvChecked && showDetailLayers
        );

        // 확대 화면에서는 기존 접근로 표시
        mapObjRefs.current.accessCctvLayer?.setVisible(
            cctvChecked && showDetailLayers
        );
    };

    // 레이어 표출 여부
    React.useEffect(() => {
        // 지도
        const map = mapObjRefs.current.map;

        // 체크박스의 체크 따라 해당 레이어 표출
        for (let i = 0; i < allLayerList.length; i++) {
            const layer = map.getLayers().getArray().find(x => x.values_.name === allLayerList[i].layer);
            if (layer) {
                // 버스승하차인원히트맵 데이터 조회 안되어 있으면 레이어 표출 하지않음.
                if (layer.getProperties().name === 'busHeatLayer'
                    || layer.getProperties().name === 'busHeatLayerGetOn'
                    || layer.getProperties().name === 'busHeatLayerGetOff') {
                    // if (!layer._isDataLoaded) {
                    //     allLayerList[i].checked = false;
                    // }
                    continue;
                }
                layer.setVisible(allLayerList[i].checked);
            }
        }

        // CCTV 체크 상태와 현재 줌에 따라 레이어 표시
        updateCctvLayerVisibility();

        // 모든 팝업 제거
        overlayContainerRef.current?.RemoveAll();
        // 유출입
        if (allLayerList.find(x => x.layer === 'inoutLayer')?.checked) {
            AddInOutTrf();
        }
        // 승하차인원현황
        if (allLayerList.find(x => x.layer === 'passLayer')?.checked) {
            AddPassenger();
        }
        // 교통정보 수집현황
        if (allLayerList.find(x => x.layer === 'trfInfLayer')?.checked) {
            AddDataProcess();
        }
        // BIS 서버 상태 현황
        if (allLayerList.find(x => x.layer === 'bisSvrStatLayer')?.checked) {
            AddBisSvrStat();
        }
    }, [allLayerList]);

    // 미래교통 인터벌
    React.useEffect(() => {
        const isSelfVhcActive = allLayerList?.some(layer => layer.layer === 'selfVhcLayer' && layer.checked);

        if (isSelfVhcActive) {
            // 켜졌을 때: 인터벌 시작
            intervalRef.current = setInterval(() => {
                mapObjRefs.current?.selfVhcLayer?.updatePositions?.();
            }, 2000);
        } else {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }

        return () => {
            clearInterval(intervalRef.current);
        };
    }, [allLayerList]);



    // 버스(차량) animation
    const startFlashFeature = () => {
        const layer = mapObjRefs.current?.busLayer;
        const styleCache = mapObjRefs.current?.styleCache;
        if (layer && styleCache) {
            const setCustomStyle = (style, progress) => {
                style.getImage().setScale(0.5 + (progress * 0.25))
                style.setZIndex(progress > 0 ? 1 : 0)
            }

            const gapMs = 5000;
            const totalMs = 600;
            runAnimationLayerList(layer, 'animationKey', [
                { gapMs: 2000 },

                // {
                //     totalMs, layerCallback: (progress) => {
                //         setCustomStyle(styleCache[11], 1 - progress)
                //         setCustomStyle(styleCache[12], progress)
                //         layer.getSource().changed()
                //     }
                // },
                // { gapMs },
                {
                    totalMs, layerCallback: (progress) => {
                        //setCustomStyle(styleCache[12], 1 - progress)
                        setCustomStyle(styleCache[13], progress)
                        layer.getSource().changed()
                    }
                },
                { gapMs },
                {
                    totalMs, layerCallback: (progress) => {
                        setCustomStyle(styleCache[13], 1 - progress)
                        setCustomStyle(styleCache[14], progress)
                        layer.getSource().changed()
                    }
                },
                { gapMs },
                {
                    totalMs, layerCallback: (progress) => {
                        setCustomStyle(styleCache[14], 1 - progress)
                        setCustomStyle(styleCache[30], progress)

                        layer.getSource().changed()
                    }
                },
                { gapMs },
                {
                    totalMs, layerCallback: (progress) => {
                        setCustomStyle(styleCache[30], 1 - progress)
                        layer.getSource().changed()
                    }
                },
                { gapMs },
            ], true)
        }
    }

    const AddEmergencyVehicleRoute = (data) => {
        const layer = mapObjRefs.current?.emergencyVehicleLayer
        layer?.addRoute(data);

        // 긴급차량 cctv : 8001, emulator cctv : 8008
        let deviceIdStr = data.deviceId;
        if(!deviceIdStr) {
            return;
        }
        let port = 8001;
        if(typeof deviceIdStr === 'string' && deviceIdStr.includes("Emulator")) {
            port = 8008;
        }

        const cctvInfo = data.selectedCctv?.openCctvInfo;
        if (cctvInfo) {
            overlayContainerRef.current?.AddOrUpdate(
                data.serviceId,
                cctvInfo.xy,
                data.selectedCctv.openPositioning,
                () => <PopupViewEmer title={cctvInfo.name} id={cctvInfo.id} port={port} />,
                (props) => props.id !== cctvInfo.id
            )
        } else {
            overlayContainerRef.current?.Remove(data.serviceId)
        }
    }

    const RemoveEmergencyVehicleRoute = (data) => {
        const layer = mapObjRefs.current?.emergencyVehicleLayer
        layer?.removeRoute(data);

        if (data.selectedCctv?.openCctvInfo) {
            overlayContainerRef.current?.Remove(data.serviceId)
        }
    }
    // 승하차인원현황
    const AddPassenger = () => {
        const data = passengerData;
        if (!data) {
            return;
        }
        let id, name, x, y, inCnt, outCnt, obj;
        for (let i = 0; i < data.length; i++) {

            id = data[i]['stationId'];
            name = data[i]['stationNm'];
            x = data[i]['x'];
            y = data[i]['y'];
            inCnt = data[i]['inCnt'];
            outCnt = data[i]['outCnt'];

            obj = { id: id, nm: name, x: x, y: y, inCnt: inCnt, outCnt: outCnt, type: "pass" };

            overlayContainerRef.current?.AddOrUpdate(
                id,
                [x, y],
                "bottom-center",
                () => <PopupViewPass item={obj} />,
                (props) => props.id !== id
            )
        }
    }
    // 유출입
    const AddInOutTrf = () => {
        const data = inOutTrfData;
        if (!data) {
            return;
        }
        let id, name, x, y, inve, outve, obj, posi;
        for (let i = 0; i < data.length; i++) {

            id = data[i]['id'];
            name = data[i]['displayTitle'];
            x = data[i]['xyRoute'][0];
            y = data[i]['xyRoute'][1];
            inve = data[i]['inve'];
            outve = data[i]['outve'];
            posi = data[i]['positioning'];

            obj = { id: id, nm: name, x: x, y: y, inve: inve, outve: outve, type: "inout" };

            overlayContainerRef.current?.AddOrUpdate(
                id,
                [x, y],
                posi,
                () => <PopupViewInout item={obj} />,
                (props) => props.id !== id
            )
        }
    }
    // 교통정보 수집현황
    const AddDataProcess = () => {
        const map = mapObjRefs.current.map;
        const center = map.getView().getCenter();
        const coordinate = toLonLat(center)
        overlayContainerRef.current?.AddOrUpdate(
            'dataProcess',
            coordinate,
            "center-center",
            () => <PopupViewDataProcess />,
            (props) => props.id !== 'dataProcess',
            99
        )
    }
    // BIS 서버 상태 현황
    const AddBisSvrStat = () => {
        const map = mapObjRefs.current.map;
        const center = map.getView().getCenter();
        const coordinate = toLonLat(center)
        overlayContainerRef.current?.AddOrUpdate(
            'bisSvrStat',
            coordinate,
            "center-center",
            () => <PopupViewBisSvrStat />,
            (props) => props.id !== 'bisSvrStat',
            99
        )
    }

    const handleClick = (event) => {
        const map = mapObjRefs.current.map;

        const lonLat = toLonLat(event.coordinate);
        const coords = event.coordinate;
        const pixel = event.pixel;
        console.log(`Clicked`, lonLat, coords, pixel);

        const {
            passengerData,
            inOutTrfData,
        } = latestProps.current;

        const popupIdList = [];
        // 유출입
        let data = inOutTrfData;
        if (data) {
            for (let i = 0; i < data.length; i++) {
                popupIdList.push(data[i]['id']);
            }
        }
        // 승하차인원현황
        // data = passengerData;
        // if(data) {
        //     for(let i = 0; i < data.length; i++) {
        //         popupIdList.push(data[i]['stationId']);
        //     }
        // }
        // 교통정보 수집현황
        popupIdList.push('dataProcess');
        // BIS 서버 상태 현황
        popupIdList.push('bisSvrStat');

        overlayContainerRef.current?.RemoveExcept(popupIdList);

        map.forEachFeatureAtPixel(pixel, function (ftr, lyr) {

            const source = lyr.getSource();
            if (source instanceof Cluster) {
                ftr = ftr.get('features')[0];
            }

            if (ftr.hasProperties()) {
                const prop = ftr.getProperties()?.properties;
                if (prop && prop.id) {
                    if (prop.type === "vds") {
                        overlayContainerRef.current?.AddOrUpdate(
                            prop.id,
                            [prop.x, prop.y],
                            "bottom-center",
                            () => <PopupViewVds item={prop} />,
                            (props) => props.id !== prop.id
                        )
                    }
                    else if (prop.type === "cctv") {
                        overlayContainerRef.current?.AddOrUpdate(
                            prop.id,
                            [prop.x, prop.y],
                            "bottom-center",
                            () => <PopupViewCctv item={prop} />,
                            (props) => props.id !== prop.id
                        )
                    }
                    else if (prop.type === "accessCctv") {
                        overlayContainerRef.current?.AddOrUpdate(
                        prop.id,
                        [prop.x, prop.y],
                        "bottom-center",
                        () => <PopupViewAccessCctv item={prop} />,
                        (props) => props.id !== prop.id
                        )
                    }
                    else if (prop.type === "vms") {
                        overlayContainerRef.current?.AddOrUpdate(
                            prop.id,
                            [prop.x, prop.y],
                            "bottom-center",
                            () => <PopupViewVms item={prop} />,
                            (props) => props.id !== prop.id
                        )
                    }
                    else if (prop.type === "dsrc") {
                        overlayContainerRef.current?.AddOrUpdate(
                            prop.id,
                            [prop.x, prop.y],
                            "bottom-center",
                            () => <PopupViewDsrc item={prop} />,
                            (props) => props.id !== prop.id
                        )
                    }
                    else if (prop.type === "surf") {
                        overlayContainerRef.current?.AddOrUpdate(
                            prop.id,
                            [prop.x, prop.y],
                            "bottom-center",
                            () => <PopupViewSurf item={prop} />,
                            (props) => props.id !== prop.id
                        )
                    }
                    else if (prop.type === "crsr") {
                        overlayContainerRef.current?.AddOrUpdate(
                            prop.id,
                            [prop.x, prop.y],
                            "bottom-center",
                            () => <PopupViewCrsr item={prop} />,
                            (props) => props.id !== prop.id
                        )
                    }
                    else if (prop.type === "park") {
                        overlayContainerRef.current?.AddOrUpdate(
                            prop.id,
                            [prop.x, prop.y],
                            "bottom-center",
                            () => <PopupViewPark item={prop} />,
                            (props) => props.id !== prop.id
                        )
                    }
                    else if (prop.type === "stop") {
                        overlayContainerRef.current?.AddOrUpdate(
                            prop.id,
                            [prop.x, prop.y],
                            "bottom-center",
                            () => <PopupViewStop item={prop} />,
                            (props) => props.id !== prop.id
                        )
                    }
                    else if (prop.type === "haza") {
                        overlayContainerRef.current?.AddOrUpdate(
                            prop.id,
                            [prop.x, prop.y],
                            "bottom-center",
                            () => <PopupViewHaza item={prop} />,
                            (props) => props.id !== prop.id
                        )
                    }
                    else if (prop.type === "bit") {
                        overlayContainerRef.current?.AddOrUpdate(
                            prop.id,
                            [prop.x, prop.y],
                            "bottom-center",
                            () => <PopupViewBit item={prop} />,
                            (props) => props.id !== prop.id
                        )
                    }
                    else if (prop.type === "los") {
                        console.log(prop.los)
                    }
                    else if (prop.type === "sign") {
                        overlayContainerRef.current?.AddOrUpdate(
                            prop.id,
                            [prop.x, prop.y],
                            "bottom-center",
                            () => <PopupViewSign item={prop} />,
                            (props) => props.id !== prop.id
                        )
                    }
                    else if (prop.type === "safezone") {
                        overlayContainerRef.current?.AddOrUpdate(
                            prop.id,
                            [prop.x, prop.y],
                            "bottom-center",
                            () => <PopupViewSafeZone item={prop} />,
                            (props) => props.id !== prop.id
                        )
                    }
                    else if (prop.type === "sgninf") {
                        overlayContainerRef.current?.AddOrUpdate(
                            prop.id,
                            [prop.x, prop.y],
                            "bottom-center",
                            () => <PopupViewSgnInf item={prop} />,
                            (props) => props.id !== prop.id
                        )
                    }
                    else if (prop.type === "school") {
                        overlayContainerRef.current?.AddOrUpdate(
                            prop.id,
                            [prop.x, prop.y],
                            "bottom-center",
                            () => <PopupViewSchoolZone item={prop} />,
                            (props) => props.id !== prop.id
                        )
                    }
                    return true;
                }
            }
        });
    }

    // map setCenter
    const SetMapView = (zoom, lng, lat) => {
        const map = mapObjRefs.current.map;
        if (map) {
            map.getView().animate({
                center: fromLonLat([lng, lat]),
                zoom: zoom,
                duration: 1000 // in milliseconds
            });
        }
    }

    // map setLayerVisible
    const SetLayerVisible = (layerName, checked) => {
        const map = mapObjRefs.current.map;
        if (map) {
            const layer = map.getLayers().getArray().find(x => x.values_.name === layerName);
            if (layer) {
                layer.setVisible(checked);
            }
        }
    }

    return (
        <React.Fragment>
            <div ref={divRef} />
            <OverlayContainer ref={overlayContainerRef} map={mapObjRefs.current?.map} />
        </React.Fragment>
    );
});

export default DashboardMap;